import { render, staticRenderFns } from "./AddFont.vue?vue&type=template&id=05c20f7e&"
import script from "./AddFont.vue?vue&type=script&lang=js&"
export * from "./AddFont.vue?vue&type=script&lang=js&"
import style0 from "./AddFont.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports